"use client";

import { ButtonLink } from "@/components/ui/button";
import Image from "next/image";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";
import { FC } from "react";
import { VacancyType } from "@/api/vacancy/mocks";
import { useTranslations } from "next-intl";
import { useMedia } from "@/hooks/system/useMedia";

const VacancyCard: FC<{ vacancy: VacancyType }> = ({ vacancy }) => {
  const { isMobile, isClient } = useMedia();

  return isClient && isMobile ? <VacancyCardMobile vacancy={vacancy} /> : <VacancyCardDesktop vacancy={vacancy} />;
};

const VacancyCardMobile: FC<{ vacancy: VacancyType }> = ({ vacancy }) => {
  const t = useTranslations("home");

  return (
    <Container>
      <div className={S.vacancy}>
        <h3 className={S.title}>{vacancy.title}</h3>
        <Image src={vacancy.img} alt={vacancy.title} width={342} height={162} />
        <span className={S.description}>{vacancy.description}</span>
        <ButtonLink href="/vacancy" variant="trBlackToBlack" arrow>
          {t("allVacancies")}
        </ButtonLink>
      </div>
    </Container>
  );
};

const VacancyCardDesktop: FC<{ vacancy: VacancyType }> = ({ vacancy }) => {
  const t = useTranslations("home");

  return (
    <Container>
      <div className={S.vacancy}>
        <div className={S.textContainer}>
          <h3 className={S.title}>{vacancy.title}</h3>
          <div className={S.descriptionWrap}>
            <span className={S.description}>{vacancy.description}</span>
            <ButtonLink href="/vacancy" variant="trBlackToBlack" arrow>
              {t("allVacancies")}
            </ButtonLink>
          </div>
        </div>
        <Image src={vacancy.img} alt={vacancy.title} width={1400} height={664} />
      </div>
    </Container>
  );
};

export default VacancyCard;
